import Vue from "vue";
import VueRouter from "vue-router";
const req = require.context("./model", false, /\.js$/);
const modules = req.keys().map(req);
var allModel = [];
modules.map(m => {
  allModel.push(...m.default)
})

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Front"),
  },
  {
    path: "/landing-page",
    name: "landingPage",
    component: () => import("@/views/pages/LandingPage/index"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/pages/NotFound/index"),
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/pages/Forbidden/index"),
  },
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("@/views/pages/redirect"),
  },
  /*{
    path: '/webview/notification/:id',
    name: 'redirect',
    component: () => import('@/views/pages/Webview/Notification')
  },*/
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/auth/AuthLayout"),
    children: [
      {
        path: "/",
        redirect: "/auth/login",
        component: () => import("@/views/auth/Login"),
      },
      {
        path: "/auth/login",
        name: "login",
        component: () => import("@/views/auth/Login"),
      },
      {
        path: "/auth/confirm-email",
        name: "confirmEmail",
        component: () => import("@/views/auth/confirmEmail"),
      },
      {
        path: "/auth/logout",
        name: "logout",
        component: () => import("@/views/auth/LogoutRedirect"),
      },
    ],
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/admin/AdminLayout"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "403",
        name: "admin403",
        component: () => import("@/views/admin/Forbidden/index"),
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("@/views/admin/dashboard"),
        default: true,
        meta: {
          model: "dashboard",
          requiresAuth: true,
        },
      },
      {
        path: "/",
        name: "index",
        component: () => import("@/views/admin/dashboard"),
        default: true,
        meta: {
          model: "dashboard",
          requiresAuth: true,
        },
      },
      {
        path: "giay-phep-sra",
        name: "index",
        component: () => import("@/views/admin/giay_phep_sra"),
        default: true,
        meta: {
          model: "giay_phep_sra",
          requiresAuth: true,
        },
      },
      {
        path: "overview",
        name: "overview",
        component: () => import("@/views/admin/overview"),
        default: true,
        meta: {
          model: "user_warning",
          requiresAuth: true,
        },
      },
      ...allModel
    ]
  },
  {
    path: "/home",
    name: "homeModule",
    component: () => import("@/views/home/HomeLayout"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "modules",
        name: "modules",
        component: () => import("@/views/home/home"),
      },
    ]
  },
]

const router = new VueRouter({
  routes,
  mode: "history",
  //base: process.env.BASE_URL,
});
export default router;